import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { host } from "../../config/Config";

export const AdminVacation = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [user, setUser] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);

  const handlePocetna = () => {
    navigate("/");
  };

  function capitalizeWords(str) {
    if (!str) return "";
    return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
  }

  const getAuthHeaders = () => {
    const token = localStorage.getItem("jwt-vlada");
    return {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    };
  };

  const handleSearch = async () => {
    if (phoneNumber.length === 0) return;
    try {
      const response = await fetch(`${host}/api/v1/users/get-user-by-phone/${encodeURIComponent(phoneNumber)}`, {
        method: "GET",
        headers: getAuthHeaders(),
      });

      const data = await response.json();
      setUser(data);
      setDialogOpen(true);
      setDeleteSuccess(false);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  const handleDeleteUser = async () => {
    try {
      const response = await fetch(`${host}/api/v1/users/${user?.id}`, {
        method: "DELETE",
        headers: getAuthHeaders(),
      });

      if (response.ok) {
        setDeleteSuccess(true);
        setUser(null);
        setPhoneNumber('');
      } else {
        alert("Greška pri brisanju korisnika.");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDeleteSuccess(false);
  };

  return (
    <div className="barber-zajednica-admin-page">
      <div className="barber-zajednica-admin-background"></div>

      <h1 style={{ marginTop: "30px", color: "white" }}>Pretraga</h1>

      <input
        style={{ width: "75%", textAlign: "center", padding: "0", marginTop: "0px" }}
        type="text"
        className="barber-zajednica-input-password"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
      />

      <button
        className="barber-zajednica-login-button-user"
        style={{ marginTop: "50px" }}
        onClick={handleSearch}
      >
        Pretraži broj
      </button>

      <button
        onClick={handlePocetna}
        className="barber-zajednica-login-button-user"
        style={{ marginTop: "30px", marginBottom: "0px", zIndex: "1000" }}
      >
        Nazad na Profil
      </button>

      {/* Dialog for user info and deletion */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>
          {deleteSuccess ? "Obaveštenje" : "Korisnik"}
        </DialogTitle>
        <DialogContent>
          {deleteSuccess ? (
            <p><strong>Korisnik uspešno obrisan</strong></p>
          ) : user?.error && user?.error.trim() !== "" ? (
            <p><strong>Nepostojeći korisnik</strong></p>
          ) : (
            <p><strong>{capitalizeWords(user?.name)}</strong></p>
          )}
        </DialogContent>
        <DialogActions>
          {!deleteSuccess && !(user?.error && user?.error.trim() !== "") && (
            <Button onClick={handleDeleteUser} color="error">
              Obriši korisnika
            </Button>
          )}
          <Button onClick={handleCloseDialog} color="primary">
            Zatvori
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
